<div class="container product-details">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center scroll-details-menu d-none">
      <ul>
        <li>
          <a class="cursor-pointer" (click)="clickToScroll('specification')">Specification</a>
        </li>
        <li *ngIf="productPrice">
          <a class="cursor-pointer" (click)="clickToScroll('emi')">EMI Calculator</a>
        </li>
        <li>
          <a class="cursor-pointer" (click)="clickToScroll('comparision')">Comparision</a>
        </li>
        <li>
          <a class="cursor-pointer" (click)="clickToScroll('reviews')">Reviews</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="row breadcrumb-wrapper g-0 gx-lg-0">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
    </div>
  </div>

  <div class="row mt-4">
    <ng-container *ngIf="!productDetailList || !productLoaded; else productTemplate">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <div class="synch-carousels">
          <div class="left child">
            <ngx-slick-carousel #slickModal="slick-carousel" class="carousel thumbs gallery" [config]="thumbSlider">
              <div ngxSlickItem *ngFor="
                  let item of skeletonService.generateFake(4);
                  let i = index
                " class="item">
                <ngx-skeleton height="30px"></ngx-skeleton>
                <ngx-skeleton height="30px"></ngx-skeleton>
                <ngx-skeleton height="30px"></ngx-skeleton>
                <ngx-skeleton height="30px"></ngx-skeleton>
              </div>
            </ngx-slick-carousel>
          </div>
          <div class="right child text-center">
            <ngx-skeleton height="400px"></ngx-skeleton>
          </div>
        </div>

        <div class="row mt-4 book-btn-padding d-none d-md-flex">
          <div class="col-12 col-lg-6 mb-2 mb-lg-0">
            <ngx-skeleton height="50px"></ngx-skeleton>
          </div>
          <div class="col-12 col-lg-6">
            <ngx-skeleton height="50px"></ngx-skeleton>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <div class="product-details-wrapper">
          <h3 class="product-name align-items-start">
            <ngx-skeleton height="30px" style="width: 100%"></ngx-skeleton>
          </h3>
          <div class="rating">
            <ngx-skeleton height="30px" style="width: 100%"></ngx-skeleton>
          </div>
          <div class="price d-lg-flex">
            <ngx-skeleton height="45px" style="width: 100%"></ngx-skeleton>
          </div>
          <div class="avail-offer">
            <ngx-skeleton height="20px" style="width: 100%"> </ngx-skeleton>
          </div>
          <div class="finance-offer">
            <div class="offer-header">
              <ngx-skeleton height="140px" style="width: 100%"></ngx-skeleton>
            </div>
          </div>

          <div class="row mt-4 d-flex">
            <div class="col-6 col-lg-6 mb-2 mb-lg-0">
              <ngx-skeleton height="25px" style="width: 50%"></ngx-skeleton>
            </div>
            <div class="col-6 col-lg-6">
              <ngx-skeleton height="25px" style="width: 50%"></ngx-skeleton>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #productTemplate>
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 position-relative">
        <div class="synch-carousels">
          <div class="left child">
            <img (click)="prevSlide()" *ngIf="productDetailList?.images?.length > 5" style="cursor: pointer"
              alt="top-blue-arrow" [src]="
                environment1 + 'images/PDP-Images/pdp-arrows/top-blue-arrow.svg'
              " />
            <ngx-slick-carousel #slickModal="slick-carousel" class="carousel thumbs gallery" [config]="thumbSlider"
              style="height: 389px">
              <div ngxSlickItem *ngFor="let item of productDetailList?.images" class="item">
                <img #cardElement
                style="cursor: pointer;"
                [src]="item.image_url"
                  (click)="changeslide(productDetailList?.images.indexOf(item))" alt="{{ productDetailList?.model }}"
                  class="img-fluid" loading="eager" />
              </div>
            </ngx-slick-carousel>
            <img (click)="nextSlide()" *ngIf="productDetailList?.images?.length > 5" style="cursor: pointer"
              alt="down-blue-arrow" [src]="
                environment1 +
                'images/PDP-Images/pdp-arrows/down-blue-arrow.svg'
              " />
          </div>
          <div class="right child text-center">
            <ngx-slick-carousel #slickHLModal="slick-carousel" class="carousel imagepreview right gallery2"
              (click)="imagePreviewpopup()" [config]="imageSlider">
              <div ngxSlickItem *ngFor="let item of productDetailList?.images" class="item">
                <img #cardElement
                style="cursor: pointer;"
             [src]="updateImageSize(item.image_url, cardElement)" alt="{{ productDetailList?.model }}"
                  class="img-fluid img-size" loading="eager" />
              </div>
            </ngx-slick-carousel>
            <button class="slick-prev .imagepreview .slick-arrow-left ms-4" (click)="prevSlide()"
              *ngIf="productDetailList?.images?.length > 1">
              <img style="margin-left: 5px" [src]="
                  environment1 + 'images/PDP-Images/pdp-arrows/right-arrow.svg'
                " alt="right-arrow" />
            </button>
            <button class="slick-next .imagepreview .slick-arrow-right me-5" (click)="nextSlide()"
              *ngIf="productDetailList?.images?.length > 1">
              <img [src]="
                  environment1 + 'images/PDP-Images/pdp-arrows/left-arrow.svg'
                " alt="left-arrow" />
            </button>
          </div>
          <p>*These images are representational</p>
        </div>
        <span class="d-md-none mobile-wish d-none">
          <a href="javascript:void(0);">
            <img alt="social-share-icon" [src]="environment1 + 'images/PDP-Images/social-share-icon.svg'"
              loading="lazy" />
          </a>
        </span>
      </div>
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <div class="product-details-wrapper">
        <div class="d-flex align-items-center justify-content-between">
          <h1 class="product-name mb-0 me-3">{{ productDetailList?.model }}</h1>
          <div class="ms-auto d-flex align-items-center gap-2">
            <a href="javascript:void(0);" (click)="openSocialSharePopup()">
              <img alt="social-share-icon" [src]="environment1 + 'images/PDP-Images/social-share-icon.svg'" loading="lazy" />
            </a>
            <button style="width: 24px; height: 24px; border: none; background-color: transparent;"
              (click)="clickToAddWishlist(productDetailList?.id)">
              <span *ngIf="!productDetailList.wishlist">
                <img alt="wishlist-white" [src]="environment1 + 'images/PDP-Images/wishlist-white.svg'" loading="lazy" />
              </span>
              <span *ngIf="productDetailList.wishlist">
                <img alt="wishlist-blue" [src]="environment1 + 'images/PDP-Images/wishlist-blue.svg'" loading="lazy" />
              </span>
            </button>
          </div>
        </div>

    
          <div class="rating">
            <span class="rating-clip" *ngIf="productDetailList?.rating">
              <span *ngIf="productDetailList?.rating > 0">{{
                productDetailList?.rating.toFixed(1)
                }}</span>
              <span *ngIf="productDetailList?.rating == 0">{{
                productDetailList?.rating
                }}</span>
              <img alt="yellow-star" [src]="environment1 + 'images/PDP-Images/yellow-star.svg'" loading="lazy" />
            </span>
            <span class="ms-2 rating-text" (click)="clickToScroll('reviews')" *ngIf="productDetailList?.rating">{{
              productDetailList?.rating.toFixed(1) }}
              Ratings
            </span>
            <span class="ms-2" *ngIf="productDetailList?.reviews">|</span>
            <span class="ms-2 rating-text" *ngIf="productDetailList?.reviews">{{ productDetailList?.rating.toFixed(1) }}
              Reviews
            </span>
          </div>
          <div class="price d-lg-flex" *ngIf="productDetailList?.price_range">
            {{
            productDetailList?.price_range
            | currency : "INR" : "symbol" : "4.0-0"
            }}
            <span class="text-nowrap d-block d-lg-flex">Ex-showroom Price*</span>
          </div>
          <div class="price d-lg-flex d-block" *ngIf="!productDetailList?.price_range">
            Please contact to Dealer.
          </div>
          <p *ngIf="priceDetail?.length == 0">
            <b>
              Prices shown are Ex-Showroom. Final offer price will be given by
              the dealer.</b>
          </p>
          <p *ngIf="priceDetail?.length > 0">
            <b> {{ priceDetail[0].text }}</b>
          </p>
          <div class="finance-carousel-loyalti" *ngIf="schemeDetailList?.length > 0">
            <owl-carousel-o [options]="carouselOptions">
              <ng-container *ngFor="let schemeDetail of schemeDetailList">
                <ng-template carouselSlide>
                  <div class="offer-box">
                    <div class="offer-content">
                      <div class="coin-icon">
                        <img [src]="environment1 + 'assets/images/Layer_2.webp'" alt="Layer-image">
                      </div>
                      <div class="offer-text">
                        <h3>Unlock fantastic reward on your online finance and booking.
                        </h3>
                        <p *ngIf="schemeDetail?.scheme_master?.scheme_bonus_type != 'Flat'">
                          Score instant {{ schemeDetail?.scheme_master?.scheme_value }}% of your booking amount as online reward points.

                        </p>
                        <span class="footnote">1 point = 1 INR</span>
                      </div>

                    </div>
                    <div class="offer-action">
                      <a (click)="gotorewardtermscondition(schemeDetail)" class="view-offers">
                        T&C applied
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M9 18l6-6-6-6"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>

            <!-- Fixed TnC Button -->

          </div>
          <div class="avail-offer" *ngIf="
              offerData?.length > 0 ">
            Avail exclusive finance offers*
          </div>
          <div class="finance-offer" *ngIf="
              offerData?.length > 0
            ">
            <div class="offer-header">
              <img alt="offers-icon" [src]="environment1 + 'images/PDP-Images/offers-icon.svg'" loading="lazy" />
              Finance Offers
              <a class="view-more ms-auto" (click)="moveToOfferList()" [routerLink]="'/offers'">View all offers</a>
            </div>
            <div class="offer-body">
              <div class="finance-carousel-sec">
                <owl-carousel-o [options]="offerOption">
                  <ng-container *ngFor="let item of offerData">
                    <ng-template carouselSlide>
                      <div class="offer-card cursor" (click)="navigateToOfferDetail(item)" style="height: 180px">
                        <div class="card-body" style="height: 50px; margin-bottom: 20px;">
                          <div class="finance-logo mb-3">
                            <img style="height: 50px;" class="img-fluid"
                              alt="{{ item.financierDetails.crmFinancierName }}"
                              src="{{ setFinancierImgUrl(item.financierId) }}" loading="lazy" />
                          </div>
                        </div>
                        <!-- <div *ngIf="item.campaignSchemePromotionalFactors">
                          <div *ngIf="item.campaignSchemePromotionalFactors"
                            [ngClass]="{' justify-content-center': item.campaignSchemePromotionalFactors?.length > 2 }"
                            class="d-flex"> -->
                        <!-- <div *ngFor="let factor of item.campaignSchemePromotionalFactors" class="row">
                              <ng-container *ngIf="factor === 'LTV'; then uppercaseValue else defaultCase">
                              </ng-container>

                              <ng-template #uppercaseValue>
                                <span style="color: #828181;font-size: 12px; text-align: center;">{{
                                  factor.toUpperCase().replace("_"," ") }}</span>
                              </ng-template>

                              <ng-template #defaultCase>
                                <ng-container *ngIf="factor === 'IRR'; else otherdefValue">
                                  <span style="color: #828181;font-size: 12px; text-align: center;">Interest Rate</span>
                                </ng-container>
                                <ng-template #otherdefValue>
                                  <span style="color: #828181;font-size: 12px; text-align: center;">{{
                                    factor.replace("_"," ") | titlecase }}</span>
                                </ng-template>
                              </ng-template>
                              <ng-container *ngIf="factor === 'DOCUMENTATION_CHARGES'; else otherValue">
                                <span
                                  style="
                                  font-size: 16px;font-weight: bold; text-align: center;">{{(item?.schemeInfo?.documentationCharges).replace("_","
                                  ") }}</span>
                              </ng-container>
                              <ng-template #otherValue>
                                <span
                                  style="font-size: 16px;font-weight: bold;text-align: center;">{{item[factor?.toLowerCase()]}}<span
                                    *ngIf="factor === 'IRR'">% onwards</span> <span *ngIf="factor === 'TENURE'">
                                    Months</span><span *ngIf="factor === 'LTV'">%</span></span>

                              </ng-template>
                            </div> -->
                        <!-- </div> -->
                        <!-- </div> -->
                        <div class="card-footer" style="margin-top: 10px;">
                          <div class="f-header text-ellipsis">
                            {{ item.financierSchemeName }}
                          </div>
                          <div class="f-desc text-ellipsis-3-line">
                            {{ item.description }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pe-0 mb-4" *ngIf="fuelType">
              <label class="form-label">Fuel</label>
              <div>
                <div class="fuel-type" *ngFor="let item of newFuelType; let i = index">
                  <input type="radio" name="fuel-type" [id]="item?.fuel_type" [checked]="item?.checked"
                    [value]="item?.fuel_type" (change)="changeFuel(item.fuel_type)" />
                  <label class="fuel" for="{{ item?.fuel_type }}">
                    {{ item?.fuel_type }}
                  </label>
                </div>
              </div>
            </div>
            <!-- <div
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-4"
              *ngIf="productDetailList.color"
            >
              <label class="form-label">Colour</label>
              <select class="form-select h-48">
                <option
                  [selected]="productDetailList.color"
                  value="{{ productDetailList.color }}"
                >
                  {{ productDetailList.color }}
                </option>
              </select>
            </div> -->
            <!-- <div class="col-12 col-sm-12 mb-4"></div> -->
          </div>
          <div class="row mt-4 book-btn-padding d-flex">
            <div class="col-6 col-lg-6 mb-2 mb-lg-0" *ngIf="removeTestDriveButton">
              <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
                data-toggle="tooltip" data-placement="top" title="Click here to Book a Test Drive"
                (click)="bootTestDrive()">
                Book a Test Drive
              </button>
            </div>
            <div class="col-6 col-lg-6">
              <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                data-toggle="tooltip" data-placement="top" title="Click here for Booking" (click)="checkAmcData()"
                data-bs-target="#booking_amc">
                Book Now At
                {{
                productDetailList?.down_payment
                | currency : "INR" : "symbol" : "4.0-0"
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div *ngIf="isUpdatedValue">
      <app-vehicle-specification id="specification" [vehicleSpecification]="vehicleDetail"
        [specificationList]="specificationList"></app-vehicle-specification>
    </div>
    <div class="body-build w-100" style="margin-top: 50px" *ngIf="productDetailList?.overview">
      <img [src]='environment1 + "assets/images/SquarePDPT.png"' class="t-image" alt="T">
      <div class="phorizontal-line"></div>
      <div class="pbottom-vertical-line"></div>
    </div>
    <div class="description" *ngIf="productDetailList?.overview">
      <h4>Product Description</h4>
      <p>{{productDetailList.overview}}</p>

    </div>
    <!-- <app-highlights id="highlights"></app-highlights> -->
    <div class="body-build w-100" style="margin-top: 50px" *ngIf="specificationLink && specificationLink != ''">
      <iframe class="playerLocation" [src]="specificationLink | safe : 'resourceUrl'" X-Frame-Options="sameorigin"
        frameborder="0" allowfullscreen></iframe>
    </div>
    <app-emi-calculator id="emi" *ngIf="productPrice" [productPrice]="productPrice"
      [loan]="productDetailList?.price_range"></app-emi-calculator>
  </div>
  <div *ngIf="isUpdatedValue">
    <app-product-compare id="comparision" [data]="productDetailList"></app-product-compare>
  </div>
  <app-product-rating id="reviews" *ngIf="productDetailList" [productId]="productId"
    [productdData]="productDetailList"></app-product-rating>
  <div *ngIf="isUpdatedValue">
    <app-product-similar-vehicle [plName]="plName" [plId]="productId"
      [data]="productDetailList"></app-product-similar-vehicle>
  </div>

  <div class="widget-menu1" *ngIf="!showWidgets1" (click)="clickOnWidget1()">
    <img alt="card-view" [src]="environment1 + 'assets/images/navigation.svg'" loading="lazy" />
  </div>
  <div class="widget-menu" *ngIf="!showWidgets" (click)="clickOnWidget()">
    <img alt="card-view" [src]="environment1 + 'assets/images/widget-menu.svg'" loading="lazy" />
  </div>
  <div class="swiss-widget1 swiss-widget show" *ngIf="showWidgets1">
    <div class="open-swiss-widget">
      <div class="row g-1">
        <div class="col-12 cursor p-0 m-0">
          <div class="swiss-box" style="border-radius: 8px 0px 0px 8px">
            <div class="text-center" [ngClass]="item.isActive ? 'border-blue' : 'border-transparent'"
              *ngFor="let item of menuList" (click)="clickToScroll(item.routeURL)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="close-swiss-widget" *ngIf="showWidgets1" (click)="closeidget1()">
      <img alt="widget-close" [src]="environment1 + 'images/PDP-Images/widget-close.svg'" loading="lazy" />
    </div>
  </div>
  <div class="swiss-widget show" *ngIf="showWidgets">
    <div class="open-swiss-widget">
      <div class="row g-1">
        <div class="col-6" style="cursor: pointer">
          <div class="swiss-box" style="border-radius: 6px 0px 0px 0px">
            <div class="text-center">
              <img alt="book-test-drive" [src]="environment1 + 'images/PDP-Images/book-test-drive.svg'"
                loading="lazy" />
            </div>
            <div class="text-center" (click)="bootTestDrive()">
              Book a test drive
            </div>
          </div>
        </div>
        <div class="col-6" style="cursor: pointer">
          <div class="swiss-box">
            <div class="text-center">
              <img alt="locate-dealer" [src]="environment1 + 'images/PDP-Images/locate-dealer.svg'" loading="lazy" />
            </div>
            <div class="text-center" [routerLink]="'/find-dealer'">
              Locate Dealers
            </div>
          </div>
        </div>
        <div class="col-6 cursor">
          <div class="swiss-box" style="border-radius: 0px 0px 0px 6px">
            <div class="text-center">
              <img alt="emi-calculator" [src]="environment1 + 'images/PDP-Images/emi-calculator.svg'" loading="lazy" />
            </div>
            <div class="text-center" *ngIf="productPrice" (click)="clickToScroll('emiCalculator')">
              EMI Calculator
            </div>
          </div>
        </div>
        <div class="col-6 cursor" style="cursor: not-allowed">
          <div class="swiss-box">
            <div class="text-center">
              <img alt="loan-offers" [src]="environment1 + 'images/PDP-Images/loan-offers.svg'" loading="lazy" />
            </div>
            <div class="text-center" style="cursor: not-allowed">
              Loan Offers
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="close-swiss-widget" *ngIf="showWidgets" (click)="closeidget()">
      <img alt="widget-close" [src]="environment1 + 'images/PDP-Images/widget-close.svg'" loading="lazy" />
    </div>
  </div>

  <!-- Modal -->
  <div *ngIf="isShowPopup" class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Move to login</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          You are not logged in, Please click "YES" to login !
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            No
          </button>
          <button type="button" class="btn btn-primary" [routerLink]="'/login'">
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="imageFullScreenModeModal" tabindex="-1" role="dialog"
    aria-labelledby="imageFullScreenModeModalLabel" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 col-sm-12 text-end">
            <button type="button" class="close" (click)="imagePreviewpopupClose()">
              <span aria-hidden="true">
                <img alt="social-close-white" [src]="
                    environment1 + 'images/PDP-Images/social-close-white.svg'
                  " loading="lazy" />
              </span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="viewfullimage">
                <div class="preview text-center w-100">
                  <ngx-slick-carousel #slickHLModal1="slick-carousel" class="carousel popimagepreview gallery2"
                    [config]="popimageSlider">
                    <div ngxSlickItem *ngFor="let item of productDetailList?.images" class="item">
                      <img  #cardElement style="cursor: pointer"  [src]="updateImageSize(item.image_url, cardElement)" alt="{{ productDetailList?.model }}"
                        class="img-size" loading="eager" />
                    </div>
                  </ngx-slick-carousel>
                </div>

                <div class="preview-thumb">
                  <ngx-slick-carousel #slickModal1="slick-carousel" class="carousel popimgthumbs"
                    style="width: 445px; margin-left: 166px" [config]="popthumbSlider">
                    <div ngxSlickItem *ngFor="let item of productDetailList?.images" class="item">
                      <img #cardElement
                style="cursor: pointer;"
                
                [src]="item.image_url" alt="{{ productDetailList?.model }}"
                        class="img-fluid" loading="eager" />
                    </div>
                  </ngx-slick-carousel>
                  <img id="f_image" (click)="prevSlide1()" style="cursor: pointer"
                    *ngIf="productDetailList?.images?.length > 5" alt="right-blue-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/right-blue-arrow.svg'
                    " />
                  <img id="s_image" (click)="nextSlide1()" style="cursor: pointer"
                    *ngIf="productDetailList?.images?.length > 5" alt="left-blue-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/left-blue-arrow.svg'
                    " />
                </div>
                <button class="slick-prev .imagepreview .slick-arrow-left ms-4"
                  *ngIf="productDetailList?.images?.length > 1">
                  <img style="margin-left: 5px; cursor: pointer" alt="right-arrow" [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/right-arrow.svg'
                    " (click)="prevSlide1()" />
                </button>
                <button class="slick-next .imagepreview .slick-arrow-right me-5"
                  *ngIf="productDetailList?.images?.length > 1">
                  <img [src]="
                      environment1 +
                      'images/PDP-Images/pdp-arrows/left-arrow.svg'
                    " style="margin-left: -8px; cursor: pointer" alt="left-arrow" (click)="nextSlide1()" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Social share popup-->
  <div class="modal fade" id="socialShareModal" tabindex="-1" role="dialog" aria-labelledby="socialShareModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 col-sm-12 text-end d-flex">
            <div class="d-flex share-header">Share this product</div>
            <button type="button" class="close" style="border: none; background: transparent"
              (click)="closeSocialSharePopup()">
              <span aria-hidden="true">
                <img alt="social-close-black" [src]="
                    environment1 + 'images/PDP-Images/social-close-black.svg'
                  " loading="lazy" />
              </span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="viewfullimage">
                <div class="social-share d-flex" style="justify-content: space-around">
                  <div>
                    <a data-toggle="tooltip" title="Twitter" href="https://twitter.com/intent/tweet?url={{
                        this.pageURL
                      }}" target="_blank" rel="noopener noreferrer">
                      <img alt="twitter" [src]="environment1 + 'images/PDP-Images/twitter.svg'" loading="lazy" />
                    </a>
                  </div>
                  <div>
                    <a data-toggle="tooltip" title="Facebook" href="https://www.facebook.com/sharer.php?u={{
                        this.pageURL
                      }}" target="_blank" rel="noopener noreferrer">
                      <img alt="facebook" [src]="environment1 + 'images/PDP-Images/facebook.svg'" loading="lazy" />
                    </a>
                  </div>
                  <div>
                    <a data-toggle="tooltip" title="WhatsApp" href="https://wa.me?text={{ this.pageURL }}"
                      target="_blank" rel="noopener noreferrer">
                      <img alt="whatsapp" [src]="environment1 + 'assets/images/whatsapp.webp'" width="100%"
                        height="100%" style="height: 34px" />
                    </a>
                  </div>
                  <div>
                    <a href="mailto:?subject=Link" data-toggle="tooltip" title="Mail" target="_blank"
                      rel="noopener noreferrer">
                      <img alt="mail-to" [src]="environment1 + 'images/PDP-Images/mail-to.svg'" loading="lazy" />
                    </a>
                  </div>
                  <div>
                    <a data-toggle="tooltip" class="cursor-pointer" title="Copy link" (click)="copyMessage()"
                      target="_blank" rel="noopener noreferrer">
                      <img alt="copy-icon" [src]="environment1 + 'images/PDP-Images/copy-icon.svg'" loading="lazy" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<button hidden id="booking_amcbtn" data-toggle="tooltip" data-placement="top" title="Click here for Booking"
  data-bs-toggle="modal" data-bs-target="#booking_amc"></button>
<div class="amcModal model">
  <div class="modal fade" id="booking_amc" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="booking_amcLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close m-1" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeModal()"></button>
        </div>
        <div class="modal-body" style="overflow: unset !important;">

          <div *ngIf="currentStep === 1">
            <div class="text-center">
              <div class="d-flex justify-content-center">
                <img [src]='environment1 + "assets/images/success.svg"' alt="success">
              </div>
              <h3>Congratulations</h3>
              <p>You are eligible for AMC plans. Secure your vehicle now.</p>
            </div>
            <div class="row d-flex">
              <div class="col-12 col-lg-6 mb-2">
                <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
                  data-bs-dismiss="modal" aria-label="Close" (click)=" bookNow()">
                  Continue without AMC
                </button>
              </div>
              <div class="col-12 col-lg-6">
                <button type="button" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                  (click)="nextStep(false)">
                  Select an AMC plan
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="currentStep === 2">
            <div class="d-flex justify-content-between align-items-center"
              style="color: #307FE2; font-size: 20px; font-weight: 700; line-height: 30px; text-align: center;">
              <h6>AMC/FMS Enquiry for New Vehicle</h6>
            </div>
            <div class="modal-body" style="overflow: unset !important;">
              <form [formGroup]="form">
                <div class="mt-2">
                  <div class="row mt-1">
                    <div class="col-12 col-sm-6 mb-4">
                      <label class="form-label">Model</label>
                      <input type="text" maxlength="45" class="form-control" placeholder="Model name"
                        formControlName="model" [(ngModel)]="productDetailList.model">
                      <!--  -->
                      <div
                        *ngIf="form.get('model')?.invalid && (form.get('model')?.dirty || form.get('model').touched)">
                        <small class="text-danger" *ngIf="form.get('model').errors?.required">Model is required.</small>
                        <small class="text-danger" *ngIf="form.get('model').errors?.maxlength">Model name cannot exceed
                          45 characters.</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Number of Vehicles</label>
                      <input type="number" maxlength="45" (change)="numberofVehicleEvent($event)" class="form-control"
                        placeholder="Vehicle" formControlName="vehicles">
                      <div
                        *ngIf="form.get('vehicles').invalid && (form.get('vehicles').dirty || form.get('vehicles').touched)">
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.required">Number of vehicles is
                          required.</small>
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.max">Number of vehicles cannot
                          exceed 99.</small>
                        <small class="text-danger" *ngIf="form.get('vehicles').errors?.min">Number of vehicles minimum
                          1.</small>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Application</label>
                      <select class="form-select" formControlName="application" (change)="terrainAMCData($event)">
                        <option value="" selected disabled>Select Application...</option>
                        <option *ngFor="let application of aplicationAmcData" [ngValue]="application">{{
                          application.display_application }}</option>
                      </select>
                      <div
                        *ngIf="form.get('application').invalid && (form.get('application').dirty || form.get('application').touched)">
                        <small class="text-danger" *ngIf="form.get('application').errors?.required">Application is
                          required.</small>
                      </div>
                      <div *ngIf="terrainvalue === true && terraindaata == false ">
                        <small class="text-danger" *ngIf="terrainvalue === true && terraindaata == false "> AMC for this
                          combination is not available, Please select another application.</small>
                      </div>
                      <div *ngIf="terraindaata === true">
                        <small class="text-danger" *ngIf="terrainvalue === true && terraindaata == true ">This is a
                          special application. Please contact your nearest dealer for suitable AMC.</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <label class="form-label">Terrain</label>
                      <select class="form-select" formControlName="terrain" (change)="onTerrainChange($event)">
                        <option value="" selected disabled>Select terrain...</option>
                        <option *ngFor="let terrain of terrainData" [value]="terrain">{{ terrain }}</option>
                      </select>
                      <div
                        *ngIf="form.get('terrain').invalid && (form.get('terrain').dirty || form.get('terrain').touched)">
                        <small class="text-danger" *ngIf="form.get('terrain').errors?.required">Terrain is
                          required.</small>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 35px;"
                    *ngIf="selectedTerrain && display == true && terrainvalue==false">
                    <div class="col-12 col-sm-6 mb-2">
                      <div class="slider-container">
                        <div class="d-flex justify-content-between" *ngIf="isHCV == true">
                          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">Annual running hours (in
                            Hrs)</label>
                          <span style="color: navy;">{{annualRunningHours | number: '1.0-0'}} hrs</span>
                        </div>
                        <div class="d-flex justify-content-between" *ngIf="isHCV == false">
                          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">Annual running KMS (in
                            Km)</label>
                          <span style="color: navy;">{{annualRunningHours | number: '1.0-0'}} KMS</span>
                        </div>
                        <ngx-slider class="mt-5" [(value)]="annualRunningHours" [options]="annualRunningHoursOptions"
                          formControlName="range1" (valueChange)="onAnnualRunningHoursChange($event)"></ngx-slider>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <div class="slider-container">
                        <div class="d-flex justify-content-between">
                          <label for="rangeSlider2" class="chasis_no" style="color: #666C84;">Duration of AMC</label>
                          <span style="color: navy;">{{amcDuration / 12}} Years</span>
                        </div>
                        <ngx-slider class="mt-5" [(value)]="amcDuration" formControlName="range2"
                          [options]="amcDurationOptions" (valueChange)="onAmcDurationChange($event)"></ngx-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="row d-flex mt-3">
              <div class="col-6">
                <button *ngIf="terrainvalue === true" type="button"
                  class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100"
                  data-bs-dismiss="modal" aria-label="Close" (click)=" bookNow()">
                  Continue without AMC
                </button>
              </div>
              <!-- [disabled]="form.invalid" -->
              <div class="col-12 col-lg-6">
                <div *ngIf="selectedTerrain && invalidReq">
                  <small class="text-danger">The plan is not available..</small>
                </div>
                <button type="button"
                *ngIf="(datadismiss == true) && (productDetailList.lob == 'HCV Const' || productDetailList.lob == 'HCV Cargo'||productDetailList.lob == 'LCV' || productDetailList.lob == 'MCV Trucks' || productDetailList.lob == 'ICV Trucks') "
                  [disabled]="form.invalid || invalidReq"
                  class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="nextStep(true)">
                  Suggest an AMC plan
                </button>

                <button type="button" data-bs-dismiss="modal" [disabled]="form.invalid || invalidReq"
                  class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="goToamc(true)"
                  *ngIf="datadismiss == false">
                  Suggest an AMC plan
                </button>
              </div>

            </div>
          </div>
          <!-- Step 3: AMC Plan -->
          <div *ngIf="currentStep === 3">
            <h2>Hello {{userData?.first_name}},</h2>
            <p class="subtitle">
              Based on your customer need, choice of vehicle, application, and related details, the following
              combination of value-added services is recommended:
            </p>

            <div class="services-table">
              <div class="table-header">
                <span class="header-item">Product</span>
                <span class="header-item">Price/yr</span>
                <span class="header-item">Number of CV</span>
                <span class="header-item">Duration (Yrs)</span>
                <span class="header-item" style="margin: 0px 0px 0px 62px;">Total Price</span>
                <span class="header-item" *ngIf="isHCV == true" style="text-align: right;
                margin: -16px -400px;">Annual Hrs</span>
                <span class="header-item" *ngIf="isHCV == false" style="text-align: right;
                margin: -16px -400px;">Annual Km</span>
              </div>

              <div class="service-item" *ngFor="let service of amcDataArray">
                <div class="service-icon-name">
                  <!-- <img [src]="service.icon" [alt]="service.name"> -->
                  <img [src]="getPlanImage(service.plan)" onerror="this.src='../../../assets/images/default_amc.png'"
                    alt="{{ service.plan }}" class="plan-icon" />

                  <!-- <img src="../../../assets/images/{{ service.amc_fms_plan?.plan?.toLowerCase().replace(/plan/gi, '').trim() }}.png" alt="{{ service.amc_fms_plan.plan }}" class="plan-icon" /> -->
                  <span class="service-name">{{ service.plan }}</span>
                  <!-- <span class="info-badge" *ngIf="service.hasInfoBadge">i</span> -->
                </div>

                <!-- Price per year with currency formatting -->
                <span class="service-price">
                  {{ service.price_per_year | currency:'INR':'symbol':'4.0-0' }}
                </span>

                <!-- Number of CVs (assuming 'numberOfCV' exists) -->
                <span class="service-cv">{{ service.number_of_chassis}}</span>

                <!-- Contract tenure in years -->
                <span class="service-tenure">{{ service['contract years'] }}</span>
                <span class="service-tenure" *ngIf="isHCV == false">{{
                  service.yearly_contract_km}}</span><!-- hr add krnas -->
                <span class="service-tenure" *ngIf="isHCV == true">{{ service.yearly_contract_hours}}</span>

                <!-- Total price calculation: price_per_year * contract years -->
                <span class="service-total"
                  style="font-size: 16px; font-weight: 700; line-height: 24px; text-align: right; color: #0A0A5F; margin: -27px -517px -2px;">
                  {{ ((service.price_per_year * (service['contract years'] || 1) ) * service.number_of_chassis) |
                  currency:'INR':'symbol':'4.0-0' }}
                </span>
              </div>
            </div>

            <div class="total-section">
              <div class="total-row"
                style="font-size: 16px; font-weight: 700; line-height: 24px; text-align: right; color: #0A0A5F;margin: 0 24px 0 10px;">
                <span>Total</span>
                <!-- <span>₹{{ totalAmount | number: '1.2-2' }}</span> -->
                <span> {{ calculateTotalAmount(amcDataArray) | currency:'INR':'symbol':'4.0-0' }}</span>
              </div>
            </div>


            <div class="action-buttons">
              <button class="secondary-button" data-bs-dismiss="modal" (click)="goToamc(false)">Make my own plan</button>
              <button class="primary-button" (click)=" bookNow('',true)" data-bs-dismiss="modal">Continue Booking with
                VAS</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
